import RoomsOfPlace from './RoomsOfPlace.container';

export default RoomsOfPlace;
